import { Component, Injector, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CategoryDefaultForm } from '../forms/category/default.form';
import { ChassisFormHandler } from '../../forms/form/classes/form-handler';
import { RouteService } from '../../routing/services/route.service';
import { ModalService } from '../../modals/services/modal.service';
import { ToastService } from '../../toast/services/toast.service';

@Component({
    selector: 'chassis-categories-category-form',
    templateUrl: './category-form.component.html',
    styleUrls: ['./category-form.component.scss']
})
export class CategoryFormComponent implements OnInit, OnDestroy {

    @Input() category: any;

    public form: ChassisFormHandler;

    constructor(protected injector: Injector, protected routeService: RouteService, protected route: ActivatedRoute, protected modalService: ModalService,
                protected toastService: ToastService) {
    }

    ngOnInit() {

        this.form = new ChassisFormHandler(this.injector, CategoryDefaultForm, this.category);

    }

    ngOnDestroy() {

    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/categories/components/category-form.component.ts